import { LOGO_DOTS, LOGO_DOT_R, LOGO_LINKS, LOGO_VIEWBOX, linkPath } from "./brand";

/** The SOMA mark in currentColor. Size it with width/height classes. */
export function SomaMark({ className }: { className?: string }) {
  return (
    <svg
      viewBox={`0 0 ${LOGO_VIEWBOX.width} ${LOGO_VIEWBOX.height}`}
      className={className}
      fill="currentColor"
      aria-hidden
    >
      {LOGO_DOTS.map(([cx, cy]) => (
        <circle key={`${cx}-${cy}`} cx={cx} cy={cy} r={LOGO_DOT_R} />
      ))}
      {LOGO_LINKS.map((q) => (
        <path key={q[0]} d={linkPath(q)} />
      ))}
    </svg>
  );
}
